export const transformBrandConfigData = (brandConfigurationReportList: any[]) => {
  if (!brandConfigurationReportList) return [];

  return brandConfigurationReportList.map((item: any) => {
    const baseTransform = {
      ...item,
      brand: item.brands__name && item.brand_id 
        ? `${item.brands__name} (${item.brand_id})`
        : item.brands__name || item.brand_id || "",
    };

    // Handle null/undefined/empty integration_status
    if (
      item.integration_status === null ||
      item.integration_status === undefined ||
      item.integration_status === ""
    ) {
      return {
        ...baseTransform,
        integration_status: "Not Ready",
        additional_information: {
          ...item.additional_information,
          step: "Properties",
          reason: "Missing mandatory fields",
        },
      };
    }

    // Handle Ready status
    if (item.integration_status === "Ready") {
      return {
        ...baseTransform,
        additional_information: {
          ...item.additional_information,
          step: "Validations",
          reason: "Completed",
        },
      };
    }

    return baseTransform;
  });
};